export default "__VITE_ASSET__Bj82jZ1m__"